import { Helper } from '../Helper';
export class GetCachedValueHelper extends Helper {
    constructor({ create }) {
        super();
        this.create = create;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.getCache);
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'HASKEY');
            },
            whenTrue: () => {
                sb.emitOp(node, 'PICKITEM');
            },
            whenFalse: () => {
                this.create(options);
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'XTUCK');
                sb.emitOp(node, 'SETITEM');
            },
        }));
    }
}

//# sourceMappingURL=GetCachedValueHelper.js.map
